import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  accessToken: null,
  loading: true,
  isAuthenticated: false,
  isMultipleSession: false,
  isAccountBlocked: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth(state, action) {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
      state.loading = false;
      state.isMultipleSession = false;
    },

    logout(state) {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.isMultipleSession = false;

      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
    },

    setLoading(state, action) {
      state.loading = action.payload;
    },

    setMultipleSessionActive(state, action) {
      state.isMultipleSession = true;
    },

    setAccountBlocked(state, action) {
      state.isAccountBlocked = action.payload;
    },

    updateUser(state, action) {
      if (!state.user) return;
      state.user = {
        ...state.user,
        ...action.payload,
      };

      localStorage.setItem("user", JSON.stringify(state.user));
    }
  },
});

export const {
  setAuth,
  logout,
  setLoading,
  setMultipleSessionActive,
  setAccountBlocked,
  updateUser,
} = authSlice.actions;

export default authSlice.reducer;